/* eslint-disable class-methods-use-this */
import 'react-perfect-scrollbar/dist/css/styles.css';
import React, { useEffect } from 'react';
import { useRoutes } from "react-router-dom";
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import theme from 'src/theme';
import DashboardLayout from 'src/layouts/DashboardLayout';
import { useRecoilState } from 'recoil';
import routes from "src/routes";
import { siteState } from "src/recoil";

const App = (props) => {
  const routing = useRoutes(routes);

  const [site, setSite] = useRecoilState(siteState);
  setSite(props.site);
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      { routing }
    </ThemeProvider>
  );
};

export default App;
